<template>
  <div class="full-width">
    <q-btn-group spread unelevated>
      <q-btn
        dense
        class="col"
        :color="selectedDate == item ? `primary` : undefined"
        v-for="(item, index) in dateList"
        :key="`${item}${index}`"
        @click="onSelectDate(item)"
      >
        {{ item.displayDate }}
      </q-btn>
    </q-btn-group>
    <template v-if="!timeSlotLoading">
      <div class="row">
        <q-btn
          dense
          unelevated
          class="col-12"
          :color="selectedTime == item ? `primary` : undefined"
          v-for="(item, index) in timeSlot"
          :key="`${item}${index}`"
          @click="onSelectTime(item)"
        >
          {{ item.displayTimeSlot }}
        </q-btn>
      </div>
    </template>
    <template v-else>
      <q-linear-progress indeterminate />
    </template>
  </div>
</template>

<script>
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export default {
  name: "SchedulePicker",
  props: ["group"],
  data() {
    return {
      selectedDate: null,
      selectedTime: null,
      timeSlot: [],
      timeSlotLoading: false,
    };
  },
  computed: {
    dateList() {
      const startDate = this.group.startDate;
      let list = [];
      for (let index = 0; index < 7; index++) {
        const date = dayjs(startDate).add(index, "day");
        list.push({
          date,
          displayDate: date.format("D MMM"),
        });
      }
      return list;
    },
  },
  methods: {
    async onSelectDate(date) {
      this.selectedDate = date;

      const branch = this.$store.state["branch"]["branch"];
      const branchCode = parseInt(branch.code);

      try {
        this.timeSlotLoading = true;
        const result = await this.$services.deliverySlot.check(
          branchCode,
          date.date.format("YYYYMMDD")
        );
        console.log({ result });

        this.timeSlot = result.hourSlots.map((i) => {
          const t = dayjs(result.datestamp, "YYYYMMDD", true);
          const start = t.add(i.hour, "hour");
          const end = start.add(1, "hour");
          // const start = dayjs()
          const displayTimeSlot = `${start.format("HH:mm")} -${end.format(
            "HH:mm"
          )}`;
          return {
            ...i,
            displayTimeSlot,
          };
        });
      } catch (error) {
        console.warn(error);
      } finally {
        this.timeSlotLoading = false;
      }
    },
    async onSelectTime(time) {
      // TODO
      this.selectedTime = time;
      console.log(">",this.selectedTime);

      const date_slot = this.selectedDate.date.format("YYYYMMDD");
      const booking_hour = this.selectedTime.hour;
      console.log(">",this.selectedDate.date, dayjs(this.selectedDate.date));
      const offsetHour = dayjs(this.selectedDate.date).utcOffset() / 60;
      console.log(">>", this.selectedDate.date);
      console.log("offsetHour", offsetHour);

      console.log(">>>>", dayjs(date_slot, "YYYYMMDD", true));
      console.log(">>>>", dayjs(date_slot, "YYYYMMDD", true).add(booking_hour - 7 + offsetHour, "hour"));

      // ISO8601 date time
      const dateTime = dayjs(date_slot, "YYYYMMDD", true)
        .add(booking_hour - 7 + offsetHour, "hour")
        .toISOString();

      console.log(">>>", dateTime, booking_hour, date_slot);

      // TODO save to store
      this.$store.commit("checkout/setDeliverySlot", {
        ...this.group,
        date_slot,
        booking_hour,
        dateTime,
      });
    },
  },
};
</script>
